/**
 * The two text lines a listed booking renders as, wherever a staff write names the bookings
 * it affects: the Remove refusal's "bookings in the way" (DNKADM-0481) and My schedule's
 * "bookings outside your new hours" (DNKADM-0490). Both lists carry the `STAFF_CONFLICT`
 * booking shape. Moved here from `RemoveStaffDialog` unchanged so both screens share them.
 */
import type { BookingConflict } from '@/api/reservations';
import { dateLabel, isoClockRangeAsIs } from '@/utils/clockTime';
import { scrubBrand } from '@/utils/whitelabel';

/** "Ann · Lesson" — first name and service, with neutral fallbacks for explicit nulls. */
export function whoAndWhat(b: BookingConflict): string {
  const who = scrubBrand(b.customerFirstName?.trim() || 'A customer');
  const what = scrubBrand(b.serviceName?.trim() || 'Booking');
  return `${who} · ${what}`;
}

/** "Thu, Nov 5, 2026 · 10:30 AM – 11:30 AM · Bay 2" — the wire's own date and wall clock. */
export function whenAndWhere(b: BookingConflict): string {
  const parts = [dateLabel(b.startTime), isoClockRangeAsIs(b.startTime, b.endTime)].filter(
    (p): p is string => p !== null && p !== '',
  );
  const bay = scrubBrand(b.resourceName?.trim() || null);
  if (bay) parts.push(bay);
  return parts.join(' · ');
}
